import qs from 'querystring'
import createReducer from '../../../../../util/createReducer'
import * as http from '../../../../../util/http'

//constant
const API_PREFIX = '/order-renew'

const NAME_PREFIX = 'ORDER_RENEW';

const DEFAULT_SIZE = 10

const RECEIVE_LIST = `${NAME_PREFIX}_RECEIVE_LIST`

const RECEIVE_DETAIL = `${NAME_PREFIX}_RECEIVE_DETAIL`

export const CHANGE_PAGE = `${NAME_PREFIX}_CHANGE_PAGE`

export const CHANGE_QUERY = `${NAME_PREFIX}_CHANGE_QUERY`

export const SHOW_MODAL = `${NAME_PREFIX}_SHOW_MODAL`

export const HIDE_MODAL = `${NAME_PREFIX}_HIDE_MODAL`

export const CHANGE_FILTER_LIST = `${NAME_PREFIX}_CHANGE_FILTER_LIST`

export const RECEIVE_STATUS_DETAIL = `${NAME_PREFIX}_RECEIVE_STATUS_DETAIL`

function trimForm(formData) {
    const newFormData = {};
    Object.keys(formData).forEach(key=>{
        const value = formData[key];
        if (typeof(value) === 'string') {
            newFormData[key] = value.trim();
        } else {
            newFormData[key] = value;
        }
    })
    newFormData.indexField = ['orderName'].map(key=>formData[key] || '').join('_');
    return newFormData;
}
//action
function getData(params, dispatch, form) {
    return http.post(`${API_PREFIX}/list?${qs.stringify(params)}`, form)
        .then(data => {
            dispatch({
                type: RECEIVE_LIST,
                data: data.data
            })
        })
}
export function getFormData(query, filterList) {
    const form = {
        "logic": "and",
        "filters": []
    }
    const keys = Object.keys(query);
    keys.forEach(key=>{
        if (query[key]) {
            form.filters.push({
                "field": key,
                "operator": filterList.find(item=>item.value === key).operator,
                "value": query[key]
            })
        }
    })
    return form;
}

export function getList() {
    return (dispatch,getState) => {
        const {orderRenew: {page, query, filterList}} = getState()
        const data = {
            page: page.index,
            size: page.size
        }
        const form = getFormData(query, filterList);
        getData(data, dispatch, form)
    };
}

export function add(formData) {
    return (dispatch, getState) => {
        formData.status = '新增';
        formData.referDomain = window.location.host;
        return http.post(`${API_PREFIX}/add`, trimForm(formData))
            .then(() => {
                dispatch({type: HIDE_MODAL})
                dispatch(getList())
            })
    }
}

export function remove(id) {
    return (dispatch, getState) => {
        return http.get(`${API_PREFIX}/delete/${id}`)
            .then(() => {
                dispatch({type: HIDE_MODAL})
                dispatch(getList())
            })
    }
}
export function update(formData) {
    return (dispatch, getState) => {
        console.info(formData);
        return http.post(`${API_PREFIX}/update/${formData.id}`, trimForm(formData))
            .then(() => {
                dispatch({type: HIDE_MODAL})
                dispatch(getList())
            })
    }
}

export function showUpdateModal(id) {
    return (dispatch, getState) => {
        return http.get(`${API_PREFIX}/detail/${id}`)
            .then((data) => {
                dispatch({type: RECEIVE_DETAIL, detail: data.data})
                dispatch({type: SHOW_MODAL, key: 'update', id})
            })
    }
}

export function getStatusDetail() {
    return (dispatch,getState) => {
        return http.get(`${API_PREFIX}/status`)
            .then((data) => {
                dispatch({
                    type: RECEIVE_STATUS_DETAIL,
                    data: (data.data || []).reduce((previous, current) => {
                        previous[current[0]] = current[1];
                        previous['全部'] = previous['全部'] + current[1]; 
                        return previous;
                    }, {'全部': 0})
                })
            })
    }
}

//reducers
const initialState = {
    list: [],
    page: {
        index: 0,
        size: DEFAULT_SIZE
    },
    total: 0,
    showModal: {
        add: false,
        delete: false,
        update: false,
        id: null
    },
    detail: {},
    filterList: [
        
            {"name": "是否需要续费域名", "componentType": "Select", "data": [{"name":"是","value":true},{"name":"否","value":false}], "isShow": false, "value": "is_need_buy_domain", "operator": "eq"},
        
            {"name": "域名", "componentType": "Text", "data": [], "isShow": false, "value": "domain", "operator": "contains"},
        
            {"name": "域名费用", "componentType": "Number", "data": [], "isShow": false, "value": "domain_money", "operator": "eq"},
        
            {"name": "域名真实费用", "componentType": "Number", "data": [], "isShow": false, "value": "domain_real_money", "operator": "eq"},
        
            {"name": "续费年限", "componentType": "Number", "data": [], "isShow": false, "value": "buy_year", "operator": "eq"},
        
            {"name": "续费类型", "componentType": "Text", "data": [], "isShow": false, "value": "type", "operator": "contains"},
        
            {"name": "项目名", "componentType": "Text", "data": [], "isShow": false, "value": "order_name", "operator": "contains"},
        
            {"name": "订单金额", "componentType": "Number", "data": [], "isShow": false, "value": "order_money", "operator": "eq"},
        
            {"name": "备注", "componentType": "Text", "data": [], "isShow": false, "value": "remarks", "operator": "contains"},
        
            {"name": "创建人id", "componentType": "Text", "data": [], "isShow": false, "value": "account_id", "operator": "contains"},
        
            {"name": "创建人名字", "componentType": "Text", "data": [], "isShow": false, "value": "account_name", "operator": "contains"},
        
            {"name": "是否自动", "componentType": "Select", "data": [{"name":"是","value":true},{"name":"否","value":false}], "isShow": false, "value": "is_auto", "operator": "eq"},
        
            {"name": "发送邮件时间", "componentType": "Datetime", "data": [], "isShow": false, "value": "send_email_time", "operator": "eq"},
        
            {"name": "最后执行时间", "componentType": "Datetime", "data": [], "isShow": false, "value": "last_task_exec", "operator": "eq"},
        
            {"name": "操作人id", "componentType": "Text", "data": [], "isShow": false, "value": "opt_account_id", "operator": "contains"},
        
            {"name": "操作人名字", "componentType": "Text", "data": [], "isShow": false, "value": "opt_account_name", "operator": "contains"},
        
            {"name": "索引字段", "componentType": "Textarea", "data": [], "isShow": false, "value": "index_field", "operator": "contains"},
        
            {"name": "来源", "componentType": "Text", "data": [], "isShow": false, "value": "refer_domain", "operator": "contains"},

            {"name": "模糊查询", "componentType": "Text", "data": [], "isShow": true, "value": "indexField", "operator": "contains", "hideCancelBtn": true},

            {"name": "订单状态", "componentType": "Select", "data": [{"name":"新增","value":"新增"},{"name":"完成","value":"完成"},{"name":"错误","value":"错误"}], "isShow": false, "value": "status", "operator": "eq"},
    ],
    query: {
        status: '',
    },
    statusDeatial: {}
}

export default createReducer(initialState,{
    [RECEIVE_LIST]: (state,{data}) => {
        return {...state,...data}
    },
    [CHANGE_PAGE]: (state, {page}) => {
        return {...state, page}
    },
    [SHOW_MODAL]: (state,{key,id}) => {
        return {...state,showModal: {...state.showModal,[key]: true,id}}
    },
    [HIDE_MODAL]: (state) => {
        return {...state,showModal: initialState.showModal}
    },
    [CHANGE_FILTER_LIST]: (state,{value}) => {
        return {...state,filterList: value}
    },
    [CHANGE_QUERY]: (state,{key,value}) => {
        return {...state,query: {...state.query,[key]: value}, page: {index: 0, size: DEFAULT_SIZE}}
    },
    [RECEIVE_DETAIL]: (state, {detail}) => {
        return {...state, detail}
    },
    [RECEIVE_STATUS_DETAIL]: (state,{data}) => {
        return {...state, statusDeatial: {...data}}
    },
})


// WEBPACK FOOTER //
// ./src/pages/home/routes/order_renew/reducers/list.js